import React from 'react';
import { COLORS, TOP_INDENTS } from '@constants';
import { Button, Typography } from '@ui';
import { Col, Row } from 'antd';
import { StyledList } from './styled';

const HowToFindPropertyId = ({ close }) => {
    return (
        <Row justify='center'>
            <Col span={16} justify='center' align='center'>
                <video width='400' controls muted style={{ marginBottom: '16px' }}>
                    <source src='https://cdn.klickly.com/boa_videos/ga4_property_id.mp4' type='video/mp4' />
                    Your browser does not support the video tag.
                </video>
                <StyledList>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Navigate to Admin:</b> Open your Google Analytics 4 dashboard and click the Admin gear
                            icon in the bottom left corner.
                        </Typography.Text>
                    </li>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Go to Property Details:</b> In the second column (Property), click on Property Settings
                            (or Property Details).
                        </Typography.Text>
                    </li>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Copy the ID:</b> Locate your numeric Property ID (e.g., 123456789) near the top right.
                            Copy this number and paste it into Klickly. (Note: Do not use your &apos;G-&apos;
                            Measurement ID).
                        </Typography.Text>
                    </li>
                </StyledList>
                <Button
                    backgroundColor={COLORS.$white}
                    padding='0 58px'
                    justify='center'
                    style={TOP_INDENTS.XL_PLUS}
                    onClick={close}
                >
                    Close
                </Button>
            </Col>
        </Row>
    );
};

export default HowToFindPropertyId;
